export default "/warning-icon-modal.c52a8919269d85ee1c43b8d23dc3976a.svg";